const headerSearch = (options) => {
  const isWrapperElementDefined = !(options === undefined || options.wrapperElement === undefined);
  // Elements
  const wrapper = isWrapperElementDefined ? options.wrapperElement : document;
  const searchIpt = wrapper.querySelector('.search-input');
  const submitBtn = wrapper.querySelector('.site-search-btn');
  const toggleBtns = wrapper.querySelectorAll('.search-item a, .mobile-search-item a, .search-wrapper .close-btn');
  const searchbar = wrapper.querySelector('.search-wrapper');
  const body = document.querySelector('body');

  if (searchbar === null) {
    return;
  }

  const onBodyClick = (event) => {
    isParentSearchbar(event.target); /* eslint-disable-line no-use-before-define */
  };

  const showSearchModule = () => {
    searchbar.classList.add('active');
    // Reset input value
    searchIpt.value = '';
    setTimeout(() => {
      searchIpt.focus();
    }, 200);
    body.addEventListener('click', onBodyClick);
  };

  const hideSearchModule = () => {
    searchbar.classList.remove('active');
    body.removeEventListener('click', onBodyClick);
  };

  const submit = () => {
    if (searchIpt.value !== '') {
      window.location.href = `/search/?q=${encodeURIComponent(searchIpt.value)}`;
    }
  };

  const isParentSearchbar = (node) => {
    if (node === null || node.classList === undefined) {
      hideSearchModule();
      return;
    }
    if (node.classList.contains('search-wrapper') || node.classList.contains('search-item') || node.classList.contains('mobile-search-item')) {
      return;
    }
    isParentSearchbar(node.parentNode);
  };

  // Event handlers
  [].map.call(toggleBtns, btn => btn.addEventListener('click', (event) => {
    event.preventDefault();
    if (searchbar.classList.contains('active')) {
      hideSearchModule();
    } else {
      showSearchModule();
    }
  }));

  searchIpt.addEventListener('keydown', (event) => {
    if (event.which === 13) {
      submit();
    }
  });

  submitBtn.addEventListener('click*', () => {
    submit();
  });

  /* submitBtn.addEventListener('click', () => {
    submit();
  }); */
  const onScroll = () => {
    if (searchbar.classList.contains('active')) {
      hideSearchModule();
    }
  };
  window.addEventListener('scroll', onScroll);
};

export default headerSearch;
